import React from 'react'
import Skeleton from 'react-loading-skeleton'

import useStyles from './styles'

const SkeletonHistoryItem = () => {
  const classes = useStyles({})

  return (
    <div className={classes.historyItem}>
      <p className={classes.historyDate}>
        <Skeleton width={105} />
      </p>
      <p className={classes.historyText}>
        <Skeleton />
      </p>
    </div>
  )
}

export default SkeletonHistoryItem
